/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const LogoutIcon = ({ isActive = false, className }) => {
  let fill;
  if (isActive === false) {
    fill = "#9a9a9a";
  } else {
    fill = "white";
  }
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 23 18"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg" test-id="sJAPrGGX">

      <mask id="path-1-inside-1_148_8122" fill={fill} test-id="SXkyuQFR">
        <path d="M6.00912 6.01077C4.82038 7.19952 4.01083 8.71407 3.68286 10.3629C3.35488 12.0117 3.52321 13.7208 4.16656 15.274C4.8099 16.8272 5.89937 18.1547 7.29718 19.0887C8.695 20.0227 10.3384 20.5212 12.0195 20.5212C13.7007 20.5212 15.3441 20.0227 16.7419 19.0887C18.1397 18.1547 19.2292 16.8272 19.8725 15.274C20.5159 13.7208 20.6842 12.0117 20.3562 10.3629C20.0282 8.71407 19.2187 7.19952 18.0299 6.01077L16.5818 7.45895C17.4841 8.36127 18.0986 9.5109 18.3475 10.7625C18.5965 12.014 18.4687 13.3113 17.9804 14.4902C17.492 15.6692 16.6651 16.6768 15.604 17.3858C14.543 18.0947 13.2956 18.4731 12.0195 18.4731C10.7435 18.4731 9.49603 18.0947 8.43501 17.3858C7.37399 16.6768 6.54703 15.6692 6.0587 14.4902C5.57036 13.3113 5.44259 12.014 5.69154 10.7625C5.94049 9.5109 6.55498 8.36127 7.45731 7.45895L6.00912 6.01077Z" test-id="9mz1Jfpk" />
      </mask>
      <path
        d="M6.00912 6.01077C4.82038 7.19952 4.01083 8.71407 3.68286 10.3629C3.35488 12.0117 3.52321 13.7208 4.16656 15.274C4.8099 16.8272 5.89937 18.1547 7.29718 19.0887C8.695 20.0227 10.3384 20.5212 12.0195 20.5212C13.7007 20.5212 15.3441 20.0227 16.7419 19.0887C18.1397 18.1547 19.2292 16.8272 19.8725 15.274C20.5159 13.7208 20.6842 12.0117 20.3562 10.3629C20.0282 8.71407 19.2187 7.19952 18.0299 6.01077L16.5818 7.45895C17.4841 8.36127 18.0986 9.5109 18.3475 10.7625C18.5965 12.014 18.4687 13.3113 17.9804 14.4902C17.492 15.6692 16.6651 16.6768 15.604 17.3858C14.543 18.0947 13.2956 18.4731 12.0195 18.4731C10.7435 18.4731 9.49603 18.0947 8.43501 17.3858C7.37399 16.6768 6.54703 15.6692 6.0587 14.4902C5.57036 13.3113 5.44259 12.014 5.69154 10.7625C5.94049 9.5109 6.55498 8.36127 7.45731 7.45895L6.00912 6.01077Z"
        stroke={fill}
        strokeWidth="4"
        mask="url(#path-1-inside-1_148_8122)" test-id="lziyzFSr" />

      <path d="M12 2.5V9" stroke={fill} strokeWidth="2" test-id="J3wlYnKW" />
    </svg>);

};

export default LogoutIcon;